<template>
  <div class="ve-list-page ar-check-page">
    <div style="display:flex;line-height:25px ;  ">
      <div  class="oneMenu" @click="itemClick('one')">
        <div style="margin-left:0px" :class="{active: actitem==='one'}" >
          <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1228', '对账单-汇总') }}</div>
      </div>
      <div  class="oneMenu" @click="itemClick('two')">
        <div style="margin-left:40px" :class="{active: actitem==='two'}" >
          <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1227', '对账单-明细') }}</div>
      </div>
    </div>
    <div v-show="actitem=='two'" class="ve-list-page__body">
      <out-two></out-two>
    </div>
    <div v-show="actitem=='one'" class="ve-list-page__body">
      <div style=" background:white;line-height:30px;border-bottom:2px solid #389">
        <div style="padding-top:3px;display:flex;width:1400px; ">
          <!-- <el-checkbox border size="small"  @change="selChg"  v-model="v_sel" true-label="Y"  false-label="N"><span style="font-size:12px;color:#389;margin-right:5px">全选</span></el-checkbox>   -->
          <span style=" font-size:12px;margin-right:10px;font-weight:600;margin-left:5px">{{ $LANG('0681', '字段查询') }}</span>
          <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable  style="width:150px; " >
                      <span v-for="item in poCol" :key='item.key'>
                          <el-option :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                      </span>
          </el-select>
          <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="inputQry" size="small" style="width:320px; height:30px; ">
            <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                          <span v-for="item in operArr" :key='item.IDSEQ'>
                              <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                          </span>
            </el-select>
            <el-button size="small" slot="append" icon="el-icon-search" @click="inputQry" ></el-button>
          </el-input>
          <span style="font-weight:600;color:#409eff;font-size:12px;margin-right:10px;margin-left:15px">{{ $LANG('0015', '应收状态') }}</span>
          <el-select @change="inputQry"  v-model="v_bill" size="small"  style="width:100px; " >
            <el-option :label="$LANG('0040', '所有记录')" value="ALL" ></el-option>
            <el-option :label="$LANG('2010', '未收完')" value="N" ></el-option>
            <el-option :label="$LANG('1980', '已收完')" value="Y" ></el-option>
          </el-select>
          <el-button type="danger"   icon="iconfont icon-daochu" @click="copyData" size="mini" style="margin-left:15px;height:30px;margin-top:1px">{{ $LANG('0220', '导出当前资料') }}</el-button>
          <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
          <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>

        </div>
      </div>
    
      <div  class="ve-list-page__table">
        <ve-table :columns="vueCol"
                  :table-data="arData"
                  :column-hidden-option="columnHiddenOption"
                  :border-around="true"
                  :border-x="true"
                  :border-y="true"
                  :fixed-header="true"
                  row-key-field-name="IDSEQ"
                  :row-style-option="rowStyleOption"
                  :cell-style-option="cellStyleOption"
                  :max-height="subHeight"
                  :virtual-scroll-option="virtualScrollOption"
                  :scroll-width="0"
                  :column-width-resize-option="columnWidthResizeOption"
                  :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                  :cell-selection-option="{enable: false}"
                  :footer-data="footerData"
                  v-loading="t_loading"
                  id="ar_check_load"
                  ref="refar">
        </ve-table>
      </div>
      <!-- 分页查询 -->
      <div  class="ve-list-page__pagination">
        <div style="float: left;padding-left:4px;font-size:12px;">
          <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
        </div> 
        <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
          <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
          <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
          <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input>
          <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
          <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
        </div>
      </div>
      <!-- 提示框 -->
      <el-dialog :show-close="false" v-dialogDrag :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
          <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
        </div>
        <div style="line-height:30px;display:flex">
          <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
          <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
        </div>
        <span slot="footer"  >
                  <el-button size="small" type="primary" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
              </span>
      </el-dialog>
      <!-- 新增、编辑表单 -->
      <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
          <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
        </div>
        <div style="height:88vh;overflow-y:auto">
          <Form :model="poRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">
                      <span v-for="(item,index) in poCol" :key="index" >
                          <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >
                              <el-date-picker size="medium" :disabled="saveFlag" type="month"  v-if="item.key==='YRMTH'" v-model="poRow[item.key]" value-format="yyyy-MM" style="width:100%" ></el-date-picker>
                              <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-else-if="item.edcss==='date'" v-model="poRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>
                              <el-input-number size="medium" :disabled="saveFlag||item.disabled==='Y'" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="poRow[item.key]" style="width:100%" ></el-input-number>
                              <el-checkbox size="medium" border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="poRow[item.key]" style="width:100%"></el-checkbox>
                              <el-select size="medium" v-else-if="item.edcss==='select'" v-model="poRow[item.key]"   style="width:100%">
                                  <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                              </el-select>
                              <el-input size="medium" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="poRow[item.key]" ></el-input>
                          </FormItem>
                      </span>
          </Form>
          <div class="one-div" style="height:28px">
            <span class="oneRow" > {{ $LANG('0700', '对账明细') }}</span>
            <el-button :disabled="saveFlag" @click="sameOk" type="danger" plain size="mini" style="height:25px;margin-top:2px;margin-left:20px;border:1px solid green">
              <i class="iconfont icon-fuzhi" style=" font-size:12px;margin-right:3px"></i>{{ $LANG('2053', '复制应收金额到实收金额') }}
            </el-button>
          </div>
          <el-table  :data="dtlData"
                    border
                    size="small"
                    class="custom-table-border"
                    :height="400"
                    :row-key="getDtlKey"
                    style="margin-top:-8px"
                    ref="refdtl"
                    v-loading="v_loading"
                    :element-loading-text="$LANG('1959', '加载中')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    show-summary
                    :summary-method="getSummary"
                    :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                    :row-class-name="tabRowClass"
                    cell-class-name="clearPadding"
                    @row-click="getRowClick"
                    highlight-current-row >
            <el-table-column :label="$LANG('0310', '序号')" width="60" type="index"></el-table-column>
            <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index"
                              :prop="item.key"
                              :label="item.title"
                              show-overflow-tooltip
                              :align="item.align"
                              :sortable="item.key!=='RN'&&item.sortable=='N'"
                              :min-width="item.width">
              <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
              <template slot-scope="scope">
                              <span v-if ="saveFlag" >
                                  <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                  <span v-else v-text="scope.row[item.key]"></span>
                              </span>
                <span v-else >
                                  <el-input type="number" :disabled="item.disabled=='Y'" @input="qtyPrc(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.down.native="nextLine(item.key,'down')" @keyup.up.native="nextLine(item.key,'up')"  :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter')"  size="mini" v-if="item.edcss=='number'" :controls="false"  v-model="scope.row[item.key]"  > </el-input>
                                  <el-date-picker v-else-if="item.edcss=='date'" :clearable="false" value-format="yyyy-MM-dd" type="date" :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )"  size="mini" v-model="scope.row[item.key]"   > </el-date-picker>
                                  <el-input  v-else-if="item.disabled=='N'"  :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" size="mini" v-model="scope.row[item.key]"  > </el-input>
                                  <span v-else v-text="scope.row[item.key]"></span>
                              </span>
              </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                :label="$LANG('0330', '操作')"
                align="center"
                width="70">
              <template slot-scope="scope">
                <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                <el-link :disabled="saveFlag" @click="dtlDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">{{ $LANG('0131', '删除') }}</span></el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="one-div"> <span class="oneRow"> {{ $LANG('0968', '费用明细') }} </span>
            <el-link  @click="feeAdd" :disabled="saveFlag" style="margin-left:20px; color:#cc0000;font-size:12px" size="mini" icon="iconfont icon-xinzeng"> {{ $LANG('0087', '新增明细') }} </el-link>
          </div>
          <el-table  :data="feeData"
                    border
                    size="small"
                    class="custom-table-border"
                    :height="160"
                    :row-key="getDtlKey"
                    style="margin-top:-8px"
                    ref="reffee"
                    :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                    :row-class-name="tabRowClass"
                    cell-class-name="clearPadding"
                    @row-click="getRowClick"
                    highlight-current-row >
            <el-table-column :label="$LANG('0310', '序号')" width="60" type="index"></el-table-column>
            <el-table-column  v-for="(item,index ) in feeCol.filter(item=>item.thide=='N')" :key="index"
                              :prop="item.key"
                              :label="item.title"
                              show-overflow-tooltip
                              :align="item.align"
                              :sortable="item.key!=='RN'&&item.sortable=='N'"
                              :min-width="item.width">
              <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
              <template slot-scope="scope">
                              <span v-if ="saveFlag" >
                                  <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                  <span v-else v-text="scope.row[item.key]"></span>
                              </span>
                <span v-else >
                                  <el-input type="number" :disabled="item.disabled=='Y'" @input="inputPrc(scope.row,scope.$index,item.key )"   size="mini" v-if="item.edcss=='number'" :controls="false"  v-model="scope.row[item.key]"  > </el-input>
                                  <el-select  v-else-if="item.key==='UNITNM'" size="mini" v-model="scope.row[item.key]"   style="width:100%">
                                      <el-option v-for="(item,index) in unitArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                  </el-select>
                                  <el-date-picker v-else-if="item.edcss=='date'" :clearable="false" value-format="yyyy-MM-dd" type="date"   size="mini" v-model="scope.row[item.key]"  style="width:100%" > </el-date-picker>
                                  <el-input  v-else-if="item.disabled=='N'"   size="mini" v-model="scope.row[item.key]"  > </el-input>
                                  <span v-else v-text="scope.row[item.key]"></span>
                              </span>
              </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                :label="$LANG('0330', '操作')"
                align="center"
                width="70">
              <template slot-scope="scope">
                <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                <el-link :disabled="saveFlag" @click="feeDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">{{ $LANG('0131', '删除') }}</span></el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="one-toolbar"><span class="spanRow"> {{ $LANG('1026', '附件明细') }}</span></div>
          <div style="display:flex" >
            <Upload
                ref="upload"
                name="upfile"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="beforeImgFile"
                :on-success="successImgFile"
                :with-credentials="true" 
                :format="['jpg','jpeg','png' ]"
                :max-size="4096"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                type="drag"
                :disabled="saveFlag"
                :on-progress="handleProgress"
                :action="uploadUrl"
                style="display: inline-block;width:200px; ">
              <div style="padding: 1px 0;width:200px;height:150px;">
                <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image>
                <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
              </div>
            </Upload>
            <div style="display:flex;margin-left:30px;"  >
                          <span v-for="(item,index) in imgData" :key="index">
                              <div v-if="item.FILEPATH&&item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" style="width:200px;height:180px;border:1px solid #e8eaec;overflow-y:hidden">
                                  <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                              </div>
                              <el-image :preview-src-list="[item.FILEPATH]"   v-else   style="width:200px;height:180px;margin-right:30px;" :src="item.FILEPATH"/>
                              <div style="width:200px;height:25px;border:1px solid #e8eaec;overflow-y:hidden">
                                  <span style="font-weight:600;font-size:12px;color:red"> {{ $LANG('0473', '文件名') }}：</span>{{item.FILENM}}
                              </div>
                              <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                                  <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                  <el-link v-if="item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" :underline="false" style="margin-right:10px;" @click="pdfShow(item.FILEPATH)"><Icon type="ios-search" />{{ $LANG('0139', '查看') }}</el-link>
                              </div>
                          </span>
            </div>
          </div>
        </div>
        <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                  <span style="float:right">
                  <i class="web-font" style="font-size:14px;margin-right:20px;color:#ed4014;font-weight:600"> {{ $LANG('1497', '提示：订单审核后不能再编辑 ， 如需编辑请弃审') }}</i>
                  <span style="margin-right:20px">
                      <i v-if="poRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                      <i v-else-if="poRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                      <i v-else-if="poRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                  </span>
                  <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu"> {{ $LANG('0132', '取消') }}</el-button>
                  <el-button :disabled="addBool||saveFlag"  @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > {{ $LANG('0130', '保存') }} </el-button>
                  </span>
        </div>

      </el-dialog>

      <!-- 引用选择框 -->
      <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
          <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
        </div>
        <pub-win v-bind:tabCol ="tableCol" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>
      </el-dialog>


      <!-- report preview -->
      <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
          <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
        </div>
        <div style="height:88vh;overflow-y:auto">
          <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
        </div>
      </el-dialog>
      <!-- 引用报表 -->
      <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
          <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
        </div>
        <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>
      </el-dialog>
      <VeColumnConfigDialog
        :visible="fieldSettingDialog.visible"
        :rows="fieldSettingDialog.rows"
        :loading="fieldSettingDialog.loading"
        :error="fieldSettingDialog.error"
        :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
        :drag-group-field="fieldSettingDialog.dragGroupField"
        :language="$store.state.lang"
        @update:visible="fieldSettingDialog.visible = $event"
        @change="updateFieldSettingsDraft"
        @confirm="saveFieldSettingsDialog"
        @reset="resetFieldSettingsDialog"
        @close="closeFieldSettingsDialog"
      />
      <!-- 上传进度 -->
      <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
          <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
        </div>
        <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>
      </el-dialog>
      <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
        <el-image  src="/assets/authorize/loading.gif" ></el-image>
      </el-dialog>
      <el-dialog v-dialogDrag :visible.sync="stfgWin"  width="350px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
          <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0649', '变更请款') }}</span>
        </div>
        <div style="line-height:40px;height:40px;font-size:12px;font-weight:600;display:flex">
          <div style="font-size:12px;width:100px">{{ $LANG('0956', '请款状态') }}</div>
          <el-select   v-model="v_stfg" :placeholder="$LANG('1664', '请选择')" size="medium" style="width:220px">
            <el-option :label="$LANG('1987', '已请款')" value="Y"  ></el-option>
            <el-option :label="$LANG('2014', '未请款')" value="N"  ></el-option>
          </el-select>
        </div>
        <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                  <span style="float:right">
                      <el-button type="info" icon="iconfont icon-shanchu" size="small"  @click="stfgWin=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                      <el-button type="primary" icon="iconfont icon-chenggong"  size="small" @click="stfgSure" style="margin-right:12px;">{{ $LANG('1638', '确定') }}</el-button>
                  </span>
        </div>
      </el-dialog>
    
    </div>
  </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user';
import { getDate, getDate2} from '../../api/Select'
import outTwo from './ar_check_two.vue'
import pubWin from '../datamgt/pubwin.vue'

import repWin from '../datamgt/repWin.vue'
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
export default {
  name:'ar_check',
  mixins: [createVeTableFieldSettingMixin({
    settingFormId: '130',
    fieldIdseq: '130',
    fieldLstseq: '1',
    mainColumnKey: 'poCol',
    tableColumnKey: 'vueCol',
    initColumnKey: 'initCol',
    tableRef: 'refar',
    generatedFixedColumnKeys: ['rownum', 'oper'],
  })],
  data () {
    return {
      v_cond:'',
      saleWin:false,
      stfgWin:false,
      loadWin:false,
      v_stfg:'',
      dtlRow:{},
      v_commit :true,
      stfgBool:true,
      btnWin:false,
      v_table:'',
      tableCol :[],
      v_key2 :'',
      v_value2 :'',
      v_bill:'N',
      selPrdWin:false,
      notNull:[],
      promptWin:false,
      v_random:'',
      prdRow:{},
      v_sel:'N',
      addFlag:'create',
      delFeeArr:[],
      rowDtl:{},
      feeData:[],
      v_row:{},
      delDtlArr:[],
      prompt:'',
      input_hold:this.$LANG('1670', '请输入内容'),
      ruleValidate:{},
      actitem:'one',
      selparam:'IDNO',
      txtparam:'',

      poRow:{},
      prdFlag:'create',
      goPage:'',
      rowIdseq:'',
      arData:[],
      cfmBool:false, //审核 权限
      addBool:false, //新增 权限
      editBool:false, //编辑权限
      cancelBool:false, //作废权限
      t_loading:false,
      current:1,
      saveFlag:false,
      allList:[], //询价单集合
      v_loading:false,
      dtlData:[],

      addWin:false,
      v_username:this.$cookies.get('v_telno'), //api 请求用户
      
      v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
      v_url:'xuper_auth/getTableRecMany' , //api请求路径
      v_formurl:'xuper_auth/getTableRecMany',
      options: [ {
        value: 50,
        label: '50'
      }, {
        value: 100,
        label: '100'
      }],
      dataCount:0,
      rowSize:50,
      dtlCol:[],
      matCol:[],
      poCol:[],
      operArr:[],
      prcCol:[],
      prcData:[],
      prdIndex:'',
      oper:'like',
      unitArr:[],

      feeCol:[],
      matWin:false,
      comboArr:[],

      repDlg:false,
      v_idno:'',
      v_replist:[],
      repArr:[],
      repUrl:'',
      repWin:false,
      v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
      v_key:'',
      chkIndex:'',
      v_tabIndex:'',
      uploadData:{}, //上传数据
      videoFlag:false,
      videoUploadPercent:0,
      imgData:[],
      fileName:'',
      uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
      Accept: "png,jpg,jpeg,gif,tiff",
      delImg:[],
      v_stfgrow:{},
      v_index:'',
      initCol:[],
      vueCol:[],
      columnHiddenOption: { defaultHiddenColumnKeys: [] },
      rowStyleOption: { clickHighlight: true },
      cellStyleOption: {
        bodyCellClass: ({ row }) => row && row.ISOVER === 'Y' ? 'table-body-cell-class1 cancel-row' : 'table-body-cell-class1 success-row',
        headerCellClass: () => 'table-head-cell-class',
        footerCellClass: () => 'table-foot-cell-class',
      },
      virtualScrollOption: { enable: false },
      footerData:[],
      headerSortKey:'',
      headerSortOrder:'',
      queryRequestId:0,
    }
  },
  components: {
    outTwo,  //注册组件
    pubWin,

    repWin,
    VeColumnConfigDialog,
    // JSX query headers are resolved at runtime.
    // eslint-disable-next-line vue/no-unused-components
    VeTableQueryHeader,
  },
  computed: {
    subHeight: function() {
      return (window.innerHeight - 190) + 'px';
    },
    dtlHeight: function() {
      return (window.innerHeight - 300) + 'px';
    },
    tabWidth: function() {
      return (window.innerWidth - 120) + 'px';
    },
    selWidth: function() {
      return (window.innerWidth - 220) + 'px';
    },
  },
  mounted () {
    this.showkey()
    getBaseData(this.v_formurl+'','userno',this.v_username,'frmidseq','130','V_USER_MOD_REP','').then(res=>{
      this.repArr =res.result
    })
    //操作符
    getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
      this.operArr =res.result
    });

    //单位
    getBaseData(this.v_url,'PARENTNO','458205','','','v_sys_base','').then(res=>{
      this.unitArr =res.result
    })

    //用户权限表
    getBaseData(this.v_url,'userno',this.v_username,'frmidseq','130','v_sys_user_priv','').then(res=>{
      if (this.v_admin==='N') { //表示有权限控制
        let row =res.result[0]
        if (row.ISADD==='N'){ //新增
          this.addBool=true
        }if (row.ISUPD==='N'){ //修改
          this.editBool=true
        }if (row.ISDEL==='N'){ //删除
          this.delBool=true
        }if (row.ISCFM==='N'){ //审核
          this.cfmBool=true
        }if (row.ISCANCEL==='N'){ //作废
          this.cancelBool=true
        }
      }
    })
    //动态生成表单验证规则
    getTabColOrData(this.v_url,'v_sys_form_fld','idseq','130','LSTSEQ','1','NOTNULL','Y').then((res) => {
      let ruleObj={}
      let ruleVal=[]
      this.notNull = res.result
      res.result.forEach(item => {
        let v_fldnm =item.FLDNM
        let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空'),trigger: 'blur'}
        ruleVal =[]
        ruleVal.push(obj1)
        ruleObj[item.FLDNO]=ruleVal
      });
      this.ruleValidate =ruleObj
    });
  },
  created () {
    if (this.v_username){
      this.getTabCol() //表列集合
      this.getArList('')
      this.comSelect()
    }else{
      let routeUrl = this.$router.resolve({
        path: '/',
        query: {lang:this.LANG },
      });
      window.open(routeUrl.href, '_self');
    }
  },
  methods: {
    stfgSure(){
      let v_cond=' set isreq=\''+this.v_stfg +'\''
      this.$axios({
        method: 'post',
        url:'xuper_auth/updateRec',
        data: {p_key:'idseq',p_value:this.v_stfgrow['IDSEQ'] ,p_table:'AR_CHK',p_cond: v_cond},
      }).then(res=>{
        if(res.code =='200')  {
          this.arData.splice(this.v_index,1,Object.assign(this.v_stfgrow,{ISREQ:this.v_stfg}))

          this.stfgWin =false
        }else{
          this.promptWin=true
          this.prompt=res.message
        }
      })
    },
    chkLink(item,key,index){
      if (key =='ISREQ'){
        this.stfgWin =true
        this.v_stfg =item['ISREQ']
        this.v_stfgrow =JSON.parse(JSON.stringify(item))
        this.v_index =index
      }
    },
    sameOk(){
      this.dtlData.forEach((item,index)=>{
        //item['ACTAMT'] =item['AMT']
        this.dtlData.splice(index,1,Object.assign(item,{ACTAMT:item['AMT'],NOAMT:0}))
      })
    },
    feeAdd(){
      let v_row ={}
      this.feeCol.forEach(item=>{
        v_row[item.key] =''
      })
      v_row={ 'STFG':'N','UNITNM':'PCS' }
      this.feeData.push(v_row)
      this.$nextTick(()=>{
        this.$refs['reffee'].doLayout()
      })
    },
    selChg(){
      if (this.v_sel =='Y'){
        this.arData.filter(item=>item.STFG=='Y').filter(item=>!item['CHKNO']).forEach((item,index)=>{
          item['SEL'] ='Y'
        })
      }else{
        this.arData.forEach((item,index)=>{
          item['SEL'] ='N'
        })
      }
    },
    copyData(){
      //导出
      this.loadWin =true
      this.$axios({
        method: 'post',
        url:'xuper_auth/report/GenExcel',
        data: {p_idseq:'130',p_lstseq:'1',p_json:JSON.stringify(this.allList),p_action:this.$LANG('0452', '对账单')},
        responseType:'blob' //关键，声明响应类型为二进制流
      }).then(response=>{
        // 从响应头解析后端设置的文件名
        // 创建Blob对象并触发下载  创建下载链接
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob)
        link.download = this.$LANG('0452', '对账单')+'_'+getDate('full')+'.xls'
        link.click()
        URL.revokeObjectURL(link.href)
        this.loadWin =false
      })
    },
    //查询图片数据
    qryImgData(idseq){
      this.imgData =[]
      getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'filety','IMG').then((res) => {
        this.imgData=[]
        if (res){
          this.imgData =res.result
        }
      })
    },
    //图片删除，操作数组
    imgDel(item,index){
      this.$confirm(this.$LANG('1594', '你确定要删除此图片吗'),this.$LANG('1442', '提示'),{
        confirmButtonText: this.$LANG('1638', '确定'),
        cancelButtonText:this.$LANG('0132', '取消'),
        customClass:'messageBox',
        showClose:false,
        closeOnClickModal:false,
        closeOnPressEscape:false,
        type:'info',
      }).then(()=>{
        this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']})
        this.imgData.splice(index, 1);
      }).catch(()=>{})
    },
    //上传显示进度
    handleProgress(event,file,fileList){
      this.videoFlag = true
      this.videoUploadPercent = Math.floor(event.percent)
    },
    //文件格式验证错误时的钩子
    handleFormatError (file) {
      this.promtWin =true
      this.prompt=this.$LANG('1455', '文件格式错误')+','+file.name + ' ' + this.$LANG('1433', '不正确, 请选择 jpg or png')
    },
    //文件超出指定文件大小限制的钩子
    handleMaxSize (file) {
      this.promtWin =true
      this.prompt=file.name + ' ' + this.$LANG('1561', '文件太大， 不能超出') + '4M'
    },
    // 文件上传成功时的钩子
    successImgFile(res,file){
      this.videoUploadPercent=0
      this.videoFlag = false
      if (res.code=='200'){
        this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})
      }else if (res.code=='201'){ // 文件哈希值存在的情况下
        this.imgData.push({FILEPATH: res.filepath,FILENM:file.name,FILETY:'IMG',PATH:'',REFIDSEQ:res.idseq,REFLSTSEQ:res.lstseq})
      }else{
        this.promptWin =true
        this.prompt =res.result
      }
    },
    //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
    beforeImgFile (res, file) {
      this.fileName= getDate('year')+'-AR'
      this.uploadData = {
        code: this.fileName ,
        p_type:'IMG',
        p_path:'/web/web_images/material/',
        p_user:this.v_username
      }
      let promise = new Promise(resolve => {
        this.$nextTick(function() {
          resolve(true);
        });
      });
      return promise;
    },

    itemClick(val){
      this.actitem =val
    },
    rowShow(){
      this.v_row ={}
      this.current =1
      this.inputQry()
    } ,
    //字段查询
    inputQry(){
      const toolbarCondition =this.oper === '!=' && isVeTableMetadataField(this.initCol, this.selparam)
        ? ` and ${this.selparam} is null `
        : buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
      const headerCondition =buildVeTableHeaderCondition(this.initCol, this.v_row, {
        typeOverrides: { SEL: 'checkbox' },
        numberOperatorDefault: '>=',
      })
      this.current =1
      this.getArList(toolbarCondition+headerCondition)
    },
    sortHeaderColumn(column){
      const key =column && column.key
      if (!key || !isVeTableMetadataField(this.initCol, key)) return
      if (this.headerSortKey === key) this.headerSortOrder =this.headerSortOrder === 'asc' ? 'desc' : 'asc'
      else {
        this.headerSortKey =key
        this.headerSortOrder ='asc'
      }
      this.inputQry()
    },
    //禁止 键盘上、下键改变值
    showkey() {
      document.onkeydown = function () {
        if (window.event.keyCode === 38 || window.event.keyCode === 40) {
          window.event.returnValue = false;
        }
      }
    },
    //表格行 按回车键 到下一行
    nextLine(key,val ){
      if (val =='enter'){
        if (key =='RMK'){
          this.chkIndex = this.chkIndex +1
          let v_count=''
          v_count =this.dtlData.length
          if (this.chkIndex >=v_count) {
            this.chkIndex =0
          }
          this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
          this.$refs[ this.chkIndex+'ACTQTY'][0].focus()
        }else{
          let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox'&&item.key!=='TAX')
          v_col.some((item,index)=>{
            if (item.key==key){
              this.$refs[ this.chkIndex+ v_col[index+1].key][0].focus()
            }
          })
        }
      }else if (val =='down'){
        this.chkIndex = this.chkIndex +1
        if (this.chkIndex >=this.dtlData.length) {
          this.chkIndex =0
        }
        this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
        this.$refs[this.chkIndex+key][0].focus()
      }else if (val =='up'){
        this.chkIndex = this.chkIndex -1
        if (this.chkIndex <=0) {
          this.chkIndex =0
        }
        this.$refs[ this.chkIndex+key][0].focus()
        this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
      }
    },
    getRowClick(row){
      this.chkIndex =row.index
    },
    btnSure(obj){
      if (this.v_key =='MATNO'){
        this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{MATTYNM:obj['MATTYNM'],MATNO:obj['IDNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],UNITNM:obj['UNITNM']} ))
        this.$refs[ this.v_tabIndex+'ACTQTY'][0].focus()
        this.chkIndex =this.v_tabIndex
      }
      this.btnWin =false
    },
    inputBtn( row, index, key){
      this.v_key =key
      if (key =='MATNO'){ //物料
        this.v_tabRow =row
        this.v_tabIndex =index
        this.v_table ='v_bs_mat'

        this.v_key2 ='modelno'
        this.v_value2 =row['MATTY']
      }
      this.btnWin =true
    },
    modelChange(){
      this.$forceUpdate()
    },
    //对指定列进行合计
    getSummary(param){
      const {columns ,data}=param
      const sums=[]
      columns.forEach((column,index)=>{
        if (index===0){
          sums[index]=this.$LANG('0280', '合计')
          return
        }
        const values =data.map(item=>Number(item[column.property]));
        if(column.property==='AMT' ||column.property==='ACTAMT'||column.property==='NOAMT'){
          sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
            const value=Number(curr)
            if(!isNaN(value)){
              return Number(Number(prev) +Number(curr) ).toFixed(1)
            }else{
              return prev
            }
          },'')
        }
      })
      return sums
    },
    getSumAr(param){
      const {columns ,data}=param
      const sums=[]
      columns.forEach((column,index)=>{
        if (index===0){
          sums[index]=this.$LANG('0280', '合计')
          return
        }
        const values =data.map(item=>Number(item[column.property]));
        if(column.property==='AMT' ||column.property==='ACTAMT'||column.property==='NOAMT'){
          sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
            const value=Number(curr)
            if(!isNaN(value)){
              return Number(Number(prev) +Number(curr) ).toFixed(1)
            }else{
              return prev
            }
          },'')
        }
      })
      return sums
    },
    dtlAdd(){
      let v_row ={}
      this.dtlCol.forEach(item=>{
        v_row[item.key] =''
      })
      v_row['MATTY'] ='PRD'
      this.dtlData.push(v_row)
      this.$nextTick(()=>{
        this.$refs['refdtl'].doLayout()
      })
    },
    repShow(row){
      if (!row['REPNO']){
        this.promptWin =true
        this.prompt =this.$LANG('1678', '请选择报表')
      }else{
        this.repWin =true
        this.repDlg =false

        this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']

      }
    },
    //报表运行
    repBtn(row){
      this.repDlg =true
      this.v_idno =row['IDNO']
      this.v_replist =this.repArr
    },

    qtyPrc(row,index,key){
      if (row['ACTAMT'] && row['AMT']) {
        row['NOAMT'] = (Number(row['AMT'])- Number( row['ACTAMT'])).toFixed(2)
      }
    },
    inputPrc(row,index,key){
      if (row['QTY'] && row['PRC']) {
        row['AMT'] = (Number(row['QTY'])*Number(row['PRC'])).toFixed(2)
      }
    },
    refSale(){
      this.v_table ='V_ORD_STK'

      this.v_random=Math.random()+''

      //this.v_cond=' and stkqty>0'
      this.saleWin=true
    },

    //出库明细
    getDtlList(idseq ){
      this.v_loading =true
      this.dtlData=[]
      getTabColOrData(this.v_url,'V_ar_chkDTL','idseq',idseq,'','','','','' ).then((res) => {
        this.dtlData =res.result
        this.$nextTick(()=>{
          this.$refs['refdtl'].doLayout()
          this.v_loading =false
        })
      })
    },
    getFeeList(idseq ){
      this.feeData=[]
      getTabColOrData(this.v_url,'V_AR_CHKFEE','idseq',idseq,'','','','','' ).then((res) => {
        this.feeData =res.result
        this.$nextTick(()=>{
          this.$refs['reffee'].doLayout()
        })
      })
    },
    //选择产品
    prdChoose(){
      if(this.dtlRow['MATTY']==='PRD'){
        this.selPrdWin=true
      }else{
        this.matWin=true
      }
    },
    //动态赋值下拉框
    comSelect(){
      this.$axios({
        method:'post',
        url: 'xuper_auth/getBaseData' ,
        data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'130',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
      }).then(res =>{
        if (res.result.length>0){
          for(let k=0;k<res.result.length;k++){
            getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
              this.comboArr[res.result[k].FLDNO] =res2.result
            })
          }
        }
      })
    },
    prdSel(row){
      this.dtlRow['MATNO']=row['MATNO']
      this.dtlRow['MATNM']=row['MATNM']
      this.dtlRow['MATTYNM']=row['MATTYNM']
      this.dtlRow['MODELNM']=row['MODELNM']
      this.dtlRow['MATDESC']=row['MATDESC']
      this.selPrdWin=false
    },
    matSure(row){
      this.dtlRow['MATNO']=row['MATNO']
      this.dtlRow['MATNM']=row['MATNM']
      this.dtlRow['MATDESC']=row['MATDESC']
      this.dtlRow['UNITNM']=row['UNITNM']
      this.matWin=false
    },
    //明细编辑、删除
    dtlDel(row,index){
      this.delDtlArr.push(row)
      this.dtlData.splice(index,1 )
    },
    feeDel(row,index){
      this.delFeeArr.push(row)
      this.feeData.splice(index,1 )
    },

    //编辑记录
    editRec(row,val,index){
      if (val==='Y'){  //仅查看
        this.saveFlag=true
      }else{
        if (row.STFG==='Y'){
          this.saveFlag=true
        }else{
          this.saveFlag=false
        }
      }
      this.delImg=[]
      this.addFlag='edit'
      this.poRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
      this.rowIdseq=row.IDSEQ
      //出库明细
      this.getDtlList(row.IDSEQ)
      this.getFeeList(row.IDSEQ)
      this.qryImgData(row['IDSEQ'])
      this.addWin=true
      this.v_commit =true
    },
    //保存记录
    saveRec(){
      this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
        if (!this.poRow[item.FLDNO] ){
          this.stfgBool =false
          this.promptWin=true
          this.prompt=item.FLDNM+this.$LANG('2051', '不能为空')
          return true
        }else{
          this.stfgBool =true
        }
      })
      //发起保存请求
      if (this.stfgBool &&this.v_commit){
        let amt_=0 , v_title=''
        //汇总明细金额
        this.dtlData.forEach(item => {
          if (item['AMT']){
            amt_ =Number(amt_)+Number(item.AMT)
          }
          this.dtlCol.filter(item =>item.notnull=='Y').some(it =>{
            if (!item[it.key]){
              v_title =it['title']
              return true
            }
          })
        })
        let v_arr  = Array.from(new Set(this.dtlData.map(item=>item.CLNTNM)) )

        if (v_title){
          this.promptWin =true
          this.prompt =v_title +this.$LANG('2051', '不能为空')
        }else if (v_arr.length>1){
          this.promptWin =true
          this.prompt =this.$LANG('0798', '明细中不能有多个客户')
        }else{
          this.$axios({
            method: 'post',
            url:'xuper_auth/formOneSave',
            data: {p_json:JSON.stringify(Object.assign(this.poRow,{CORPID:this.v_corpid,AMT:amt_.toFixed(2)})), p_table:'ar_chk',frmid:'130'},
          }).then(res=>{
            if(res.result ==='OK')  {
              let idseq_ =res.idseq
              //1、出库明细保存：批量保存
              this.$axios({
                method: 'post',
                url:'xuper_auth/batDtlSave2',
                data: {p_json:JSON.stringify(this.dtlData), p_table:'ar_chkDTL',p_idseq:idseq_ , p_action:'S' },
              }).then(res=>{
                if (res.code!=='200'){
                  this.promtWin=true
                  this.prompt=res.result
                }else{
                  this.getArList('')
                }
              })
              this.$axios({
                method: 'post',
                url:'xuper_auth/batDtlSave2',
                data: {p_json:JSON.stringify(this.feeData), p_table:'ar_chkfee',p_idseq:idseq_ , p_action:'S' },
              })
              //出库明细删除
              for (let k=0;k<this.delDtlArr.length;k++) {
                if (this.delDtlArr[k].LSTSEQ ) {
                  this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:idseq_,p_key2:'lstseq',p_value2:this.delDtlArr[k].LSTSEQ, p_table:'ar_chkdtl', p_action:'D' },
                  })
                }
              }
              for (let k=0;k<this.delFeeArr.length;k++) {
                if (this.delFeeArr[k].LSTSEQ ) {
                  this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:idseq_,p_key2:'lstseq',p_value2:this.delFeeArr[k].LSTSEQ, p_table:'ar_chkfee', p_action:'D' },
                  })
                }
              }
              //3、图片保存
              for(var k=0;k<this.imgData.length;k++){
                this.$axios({
                  method: 'post',
                  url:'xuper_auth/tableBodySave',
                  data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:idseq_},
                })
              }
              //图片删除处理
              for(let k=0;k<this.delImg.length;k++){
                let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                this.$axios({
                  method: 'post',
                  url:'xuper_auth/delTabRec',
                  data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                }).then(res=>{
                  if(res.code !=='200')  {
                    this.prompt=res.message
                    this.promptWin=true
                  }else{
                    //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                    if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                      this.$axios({
                        method: 'post',
                        url: '/xuper_oss/ftpDelete',
                        data: {p_path:'/volume1'+v_path},
                      }).then(res=>{
                        console.log(res.result)
                      })
                    }
                  }
                })
              }
              this.v_commit =false
              this.addWin =false

            }else{
              this.promptWin=true
              this.prompt=res.result
            }
          })
        }
      }
    },
    //新增
    addRec(){
      this.addWin=true
      this.poRow={ICDTTM:getDate('day'),'IDSEQ':'',IDTY:'SALEOUT',STKNO:'15412'}
      this.dtlData=[]
      this.saveFlag=false
      this.v_commit =true
      this.delImg=[]
    },
    //表行记录css
    tableRowClass({row, rowIndex}) {
      if (row.STFG  === 'Y') {
        return 'success-row';
      } else if (row.STFG ==='X') {
        return 'cancel-row';
      }
      return '';
    },
    getRowKey(row){
      return row.IDSEQ
    },
    getDtlKey(row){
      return row.index
    },
    tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
      row.index =rowIndex
    },
    arRowClass({row,rowIndex}){  //为 table数据添加 index 字段
      row.index =rowIndex
      if (row['ISOVER']=='Y') {  //未开始
        return 'cancel-row';
      }
      return 'success-row';
    },
    //状态变更
    stfgRec(row,val,index){
      let v_comm='' ,v_cond='', v_chkuser='',v_chkdttm=''
      if (val==='Y'){
        v_comm=this.$LANG('0134', '审核')
      }else if (val==='N'){
        v_comm=this.$LANG('0137', '弃审')
      }else if (val==='X'){
        v_comm=this.$LANG('0257', '作废')
      }
      if (val=='Y'){
        v_chkuser =this.v_usernm
        v_chkdttm=getDate('full')
        v_cond =' set stfg=\''+val+'\' ,chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
      }else{
        v_cond =' set stfg=\''+val+'\' ,chkuser=null,chkdttm=null'
      }
      this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗'),this.$LANG('1442', '提示'),{
        confirmButtonText: this.$LANG('1638', '确定'),
        cancelButtonText:this.$LANG('0132', '取消'),
        customClass:'messageBox',
        showClose:false,
        type:'info',
      }).then(()=>{
        var vm=this;
        this.$axios({
          method: 'post',
          url:'xuper_auth/updateRec',
          data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'ar_chk',p_cond: v_cond},
        }).then(res=>{
          if(res.code =='200')  {
            if (val=='X'){
              this.arData.splice(index,1)
            }else{
              Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
            }
          }else{
            this.prompt=res.result
            this.promptWin =true
          }
        })
      }).catch(()=>{})


    },

    goNext(){
      if (this.goPage){
        this.changePage(this.goPage)
        this.current =Number(this.goPage)
      }else{
        this.$alert(this.$LANG('1721', '请输入跳至页数'), this.$LANG('1442', '提示'), {
          confirmButtonText: this.$LANG('1638', '确定'),
          showClose:false,
          type:'info'
        })
      }
    },
    //表格页面导航
    changePage(index){
      var _start = ( index - 1 ) * this.rowSize;
      var _end = index * this.rowSize
      this.current =index
      this.arData = this.allList.slice(_start,_end);
      this.getFootSumAr()
    },
    //初始化查询页条数
    initPage(){
      //产品明细
      this.dataCount =this.allList.length //总条数
      // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
      if (this.allList.length < this.rowSize){
        this.arData = this.allList
      }else{

        if (this.current >1){
          this.changePage(this.current)
        }else{
          this.arData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
        }
      }
      this.getFootSumAr()

    },
    getFootSumAr(){
      const totals = ['AMT', 'ACTAMT', 'NOAMT'].reduce((result, key) => {
        const value = (this.arData || []).reduce((sum, row) => Number(sum) + Number(row[key] || 0), 0)
        result[key] = value ? value.toLocaleString() : ''
        return result
      }, {})
      this.footerData = [Object.assign({rowKey: 0, index: this.$LANG('0280', '合计')}, totals)]
    },
    getArList(cond){
      const requestId =++this.queryRequestId
      this.t_loading=true
      let v_cond=''
      if (this.v_bill =='N'){
        v_cond=' and isok=\'N\''
      }else if (this.v_bill =='Y'){
        v_cond=' and isok=\'Y\''
      }
      const orderField =isVeTableMetadataField(this.initCol, this.headerSortKey)
        ? this.headerSortKey
        : (isVeTableMetadataField(this.initCol, this.selparam) ? this.selparam : 'IDNO')
      const orderDirection =this.headerSortKey ? this.headerSortOrder : 'desc'
      getTabColOrData(this.v_url,'V_ar_chkQRY','','','CORPID',this.v_corpid,'','',`${cond}${v_cond} order by ${orderField} ${orderDirection}`).then((res) => {
        if (requestId !== this.queryRequestId) return
        this.allList =res.result || []
        this.initPage()
        this.$nextTick(() => { //有固定列时 查询后重新布局
          const table = this.$refs.refar
          if (table && typeof table.doLayout === 'function') table.doLayout()
        })
      }).catch(error=>{
        if (requestId !== this.queryRequestId) return
        this.prompt =error.message || this.$LANG('1641', '查询失败')
        this.promptWin =true
      }).finally(()=>{
        if (requestId === this.queryRequestId) this.t_loading=false
      })
    },

    //获取表列头字段  v-enter-number
    getTabCol(){
      var vm=this
      getTabColOrData(this.v_url,'v_sys_form_fld','idseq','130','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
        vm.initCol = res.result
        return vm.loadInitialFieldSettings().then(() => {
          const fieldRows = vm.sortFieldRows(vm.initCol)
          vm.poCol = []
          vm.vueCol = []
          fieldRows.forEach(rowField => {
            const itcol = rowField
            const title = vm.$translate.getColTitle(itcol, vm.$store.state.lang)
            vm.poCol.push({
              title,
              key: itcol.key,
              align: itcol.align,
              width: itcol.width,
              thide: itcol.THIDE,
              fhide: itcol.FHIDE,
              edcss: itcol.EDCSS,
              disabled: itcol.DISABLED,
              dotnum: itcol.DOTNUM,
              sortable: itcol.SORTABLE,
            })
            if (itcol.THIDE !== 'N') return
            vm.vueCol.push({
              field: itcol.key,
              key: itcol.key,
              title,
              align: itcol.align,
              width: Number(itcol.width) || 120,
              sortable: false,
              ellipsis: { showTitle: true },
              renderHeaderCell: ({column}) => <VeTableQueryHeader
                title={column.title}
                edcss={itcol.EDCSS}
                value={this.v_row[itcol.key]}
                operator={this.v_row[`#OPER${itcol.key}`]}
                defaultOperator=">="
                showDateOperator={false}
                sortable={itcol.key !== 'RN' && itcol.key !== 'SEL' && itcol.SORTABLE === 'N' && itcol.EDCSS !== 'checkbox'}
                sortOrder={this.headerSortKey === itcol.key ? this.headerSortOrder : ''}
                options={['select', 'checkbox'].includes(String(itcol.EDCSS || '').toLowerCase()) ? (this.comboArr[itcol.key] || []) : []}
                on-input={(value) => this.$set(this.v_row, itcol.key, value)}
                on-operator-change={(value) => this.$set(this.v_row, `#OPER${itcol.key}`, value)}
                on-title-click={() => this.sortHeaderColumn(column)}
                on-query={this.inputQry}
              />,
              renderBodyCell: ({row, rowIndex}) => {
                const value = row[itcol.key]
                if (itcol.key === 'IDNO') return <el-link underline={false} on-click={() => this.repBtn(row)}><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px">{value}</div></el-link>
                if (itcol.key === 'SEL') return <el-checkbox disabled={row.STFG !== 'Y' || !!row.CHKNO} true-label="Y" false-label="N" v-model={row[itcol.key]} style="width:100%">&nbsp;</el-checkbox>
                if (String(itcol.EDCSS || '').toLowerCase() === 'checkbox') {
                  return <el-link underline={false} on-click={() => this.chkLink(row, itcol.key, rowIndex)}>{value === 'Y' ? <el-tag size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> : <el-tag size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag>}</el-link>
                }
                return <span style="float:left">{value}</span>
              },
            })
          })
          vm.vueCol.unshift({
            field: 'index',
            key: 'rownum',
            title: vm.$LANG('0310', '序号'),
            width: 60,
            align: 'center',
            fixed: 'left',
            disableResizing: true,
            renderBodyCell: ({rowIndex}) => rowIndex + 1,
            renderHeaderCell: ({column}) => <div class="ar-check-sequence-header"><div class="ar-check-sequence-header__title">{column.title}</div><el-link on-click={vm.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div>,
          })
          vm.vueCol.push({
            field: 'oper0',
            key: 'oper',
            title: vm.$LANG('0330', '操作'),
            width: 210,
            align: 'center',
            fixed: 'right',
            disableResizing: true,
            renderBodyCell: ({row, rowIndex}) => <div>
              <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link on-click={() => this.editRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
              {row.STFG === 'N' ? <span><i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link on-click={() => this.editRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link><i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link on-click={() => this.stfgRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0134', '审核')}</span></el-link><i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link on-click={() => this.stfgRec(row, 'X', rowIndex)} underline={false}><span style="font-size:12px">{this.$LANG('0257', '作废')}</span></el-link></span> : null}
              {row.STFG === 'Y' ? <span><i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link on-click={() => this.stfgRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0137', '弃审')}</span></el-link></span> : null}
            </div>,
          })
          vm.applyFieldSettingRows()
          return res
        })
      })
      getTabColOrData(this.v_url,'v_sys_form_fld','idseq','130','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
        for (let k=0; k<res.result.length; k++){
          vm.dtlCol.push({ //向数组的开头 添加序列号
            title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
            key: res.result[k].key,
            align: res.result[k].align,
            width: res.result[k].width,
            thide:res.result[k].THIDE,
            fhide:res.result[k].FHIDE,
            edcss:res.result[k].EDCSS,
            disabled:res.result[k].DISABLED,
            dotnum:res.result[k].DOTNUM,
            sortable:res.result[k].SORTABLE,
            notnull:res.result[k].NOTNULL,
          })
        }
      })
      getTabColOrData(this.v_url,'v_sys_form_fld','idseq','130','lstseq','4','','',' order by sortby,lstseq' ).then((res) => {
        for (let k=0; k<res.result.length; k++){
          vm.feeCol.push({ //向数组的开头 添加序列号
            title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
            key: res.result[k].key,
            align: res.result[k].align,
            width: res.result[k].width,
            thide:res.result[k].THIDE,
            fhide:res.result[k].FHIDE,
            edcss:res.result[k].EDCSS,
            disabled:res.result[k].DISABLED,
            dotnum:res.result[k].DOTNUM,
            sortable:res.result[k].SORTABLE,
            notnull:res.result[k].NOTNULL,
          })
        }
      })

    },
  }
}
</script>
<style scoped lang="less">
    .ar-check-page {
        display: flex;
        flex-direction: column;
        height: calc(100% - 32px);
        min-height: 0;
        overflow: hidden;
        background: white;
    }
  
 

.active {
  color: #389;
  border-bottom:3px solid #cc0000;
  margin-right:2px;
}
.oneMenu{
  display:flex;
  flex-direction:column;
  line-height:25px;
  background:white;
  margin-top:3px;
  font-size:13px;
  font-weight: 600;
}
.oneMenu:hover{
  cursor: pointer;
  color:#cc0000;
  background:#f7f8f9;
  font-weight:700;
}
.item-width  {
  width: 32%;
  color:#409EFF;
}
.pub_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}
</style>
<style scoped lang="less">
.custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
  border-color: rgb(184, 181, 181);
  border-width: 1px;
}
.el-table {
  th {
    padding: 0 ;
  }
  thead{
    height: 15px;
    color:rgb(11, 11, 59);
    font-size:12px;
    background:rebeccapurple;
  }
  td {
    padding: 5px ;
    font-size:11px;
  }
}
.el-dialog__body{
  padding: 10px;
}
.el-dialog__header{
  padding: 0px;
}
.el-dialog__footer{
  padding: 5px;
  border-top:1px solid #ccc;
}
.el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
//.el-dialog__headerbtn i { background:white;font-size: 20px;  }
.el-table .success-row {
  color:black;
}
.ve-table .success-row {
  color:black;
}
.el-table .cancel-row {
  color: red;
}
.ve-table .cancel-row {
  color: red;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
  border-color :#3d77eb;
}
.el-checkbox__input.is-disabled+span.el-checkbox__label{
  color:#3d77eb
}
.messageBox .el-message-box__content{
  border-top: 1px solid #EBEEF5;
  height: 50px;
}
.el-message-box__message p{
  line-height: 30px;
}
.messageBox .el-message-box__btns{
  padding: 20px 15px 0;
}
.messageBox .el-message-box__header{
  background:#409eff;
}
.messageBox .el-message-box__title{
  color:white ;
  font-size:14px;
}
</style>
